<template>
	<div
		class="grid grid-cols-7 md:grid-cols-14 gap-y-1 gap-x-3 items-center justify-between px-3 py-3"
	>
		<div
			v-if="
				!(
					referenceTradable.user.type == 'FARMER' &&
					referenceTradable.trade == 'SELL'
				)
			"
			class="col-span-1 text-gray-900 whitespace-nowrap font-semibold"
		>
			{{ match.offer.qty.mt }} t
		</div>
		<div
			v-if="
				!(
					referenceTradable.user.type == 'FARMER' &&
					referenceTradable.trade == 'SELL'
				)
			"
			class="col-span-2 text-gray-500 truncate text-sm xl:text-base"
		>
			<!-- {{ productString }} -->
			{{
				$cropOptions.getLocalizedLabel(
					match.offer.product.grade,
					$cropOptions.productGradeOptions
				)
			}}
		</div>
		<div
			v-if="
				referenceTradable.user.type == 'FARMER' &&
				referenceTradable.trade == 'SELL'
			"
			class="col-span-3 text-gray-500 text-sm xl:text-base"
		>
			<!-- {{ productString }} -->
			{{
				$cropOptions.getLocalizedLabel(
					match.offer.product.grade,
					$cropOptions.productGradeOptions
				)
			}}
			{{ __("Harvest") }} {{ match.offer.product.harvest || __("n.a.") }}
		</div>

		<!-- location -->
		<div
			class="col-span-4 md:col-span-3 text-gray-500 text-sm xl:text-base leading-4 flex gap-x-2 flex-wrap xl:gap-x-3 items-center"
		>
			<div
				v-if="
					referenceTradable.user.type == 'FARMER' &&
					referenceTradable.trade == 'SELL' &&
					match.offer.location.mode == 'DAP' &&
					match.offer.location.optional_transport
				"
				class="whitespace-nowrap"
			>
				{{
					$cropOptions.getLocalizedLabel(
						"FCA",
						$cropOptions.locationModeOptions
					)
				}}
			</div>
			<div v-else class="whitespace-nowrap">
				{{
					$cropOptions.getLocalizedLabel(
						match.offer.location.mode,
						$cropOptions.locationModeOptions
					)
				}}
			</div>

			<div class="whitespace-nowrap">
				<span
					v-if="
						(referenceTradable.user.type == 'FARMER' &&
							referenceTradable.trade == 'SELL' &&
							match.offer.location.mode == 'DAP' &&
							match.offer.location.optional_transport) ||
						(referenceTradable.user.type == 'FARMER' &&
							referenceTradable.trade == 'SELL' &&
							match.offer.location.mode == 'FCA')
					"
				>
					{{ referenceTradable.location.address.city }}
				</span>
				<span v-else>
					{{ match.offer.location.address.city }}
				</span>
				<span
					v-if="
						match.distance_km_road &&
						!(
							referenceTradable.user.type == 'FARMER' &&
							referenceTradable.trade == 'SELL' &&
							match.offer.location.mode == 'DAP' &&
							match.offer.location.optional_transport
						) &&
						!(
							referenceTradable.user.type == 'FARMER' &&
							referenceTradable.trade == 'SELL' &&
							match.offer.location.mode == 'FCA'
						)
					"
				>
					({{ match.distance_km_road.toFixed(0) }} km)
				</span>
			</div>
			<!-- {{ locationString }} {{ __('approx.') }} {{ (1*match.distance_km_road).toFixed(0) }} km -->
		</div>

		<div
			v-if="
				referenceTradable.user.type == 'FARMER' &&
				referenceTradable.trade == 'SELL'
			"
			class="col-span-7 md:col-span-4 text-gray-500 text-sm xl:text-base"
		>
			{{ $cropOptions.dateToString(this.match.offer, this.locale) }}
		</div>

		<div
			v-if="
				!(
					referenceTradable.user.type == 'FARMER' &&
					referenceTradable.trade == 'SELL'
				)
			"
			class="hidden md:flex flex-nowrap text-gray-500"
		>
			<ui-icon name="arrow-left" stroke="2" class="w-5 h-5" />
			<ui-icon name="arrow-right" stroke="2" class="w-5 h-5" />
		</div>

		<!-- price -->
		<div :class="priceContainerCss">
			<div
				class="text-gray-900 font-semibold xl:flex xl:gap-x-3 items-center"
				v-if="match.price_estimate"
			>
				<div>
					<span
						v-if="
							!(
								referenceTradable.user.type == 'FARMER' &&
								referenceTradable.trade == 'SELL' &&
								match.offer.location.mode == 'DAP' &&
								match.offer.location.optional_transport
							)
						"
					>
						{{ __("approx.") }}
					</span>
					{{ $cropOptions.formatLocalizedNumber(match.price_estimate) }} €/t
				</div>

				<ui-tooltip
					v-if="
						!(
							referenceTradable.user.type == 'FARMER' &&
							referenceTradable.trade == 'SELL'
						)
					"
					class="text-sm xl:text-base font-normal"
					:text="
						__('This price is estimated based on freight cost indications')
					"
				>
					<template v-slot:label
						><span class="cursor-help text-orange-500"
							>{{ __("Freight cost") }} ca.
							{{ $cropOptions.formatLocalizedNumber(match.freight_cost_eur) }}
							€/t</span
						></template
					>
				</ui-tooltip>
			</div>

			<div
				class="text-gray-900 font-semibold flex items-center"
				v-else-if="match.offer.price.mt"
			>
				<div class="mr-3">
					{{
						match.offer.price.mt == null
							? ""
							: $cropOptions.formatLocalizedNumber(match.offer.price.mt) +
							  " €/t " +
							  matchPriceWarning
					}}
				</div>

				<div
					v-if="
						!(
							referenceTradable.user.type == 'FARMER' &&
							referenceTradable.trade == 'SELL' &&
							match.offer.location.mode == 'FCA'
						)
					"
					class="text-gray-500 font-normal text-sm xl:text-base"
				>
					{{ __("without freight charges") }}
				</div>
				<!-- __('This price is net of any freight charges')"-->
			</div>

			<div class="text-gray-500 xl:flex items-center text-sm" v-else>
				{{ __("No price provided") }} &nbsp;<br />
				<span v-if="match.freight_cost_eur">
					{{
						__("messages.freight_charges", {
							args: {
								cost: $cropOptions.formatLocalizedNumber(
									match.freight_cost_eur
								),
							},
						})
					}}
				</span>
			</div>

			<ui-button
				type="primary"
				v-on:click="
					$bus.$emit(
						'toggle-iframe-modal',
						$route('bid.create', {
							targetType: match.offer.trade,
							targetId: match.offer.id,
							sourceId: referenceTradable.id,
						}) + '?iframe_modal=true'
					)
				"
				class="ml-auto text-sm flex-shrink-0"
				>{{
					match.offer.trade == "BUY"
						? referenceTradable.user.type == "FARMER"
							? __("Offer Quantity")
							: __("Offer")
						: __("Bid")
				}}</ui-button
			>
		</div>
	</div>
</template>

<script>
let options = require("../cropOptions.js");

export default {
	props: {
		match: {
			type: Object,
			required: true,
		},
		referenceTradable: {
			type: Object,
			required: true,
		},
		showQuality: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	computed: {
		bidLabel: function () {
			return this.referenceTradable.trade == "BUY"
				? this.__("Bid")
				: this.__("Offer");
		},
		productString() {
			return (
				this.match.offer.product.origin +
				" " +
				this.__(
					options.getLabel(
						this.match.offer.product.grade,
						options.productGradeOptions
					)
				)
			);
		},
		locationString() {
			return options.locationToString(this.match.offer);
		},
		dateString() {
			return options.dateToString(this.match.offer, this.locale);
		},
		placeBidUrl() {
			return `${
				window.baseUrl
			}/bid/create/offer_${this.match.offer.trade.toLowerCase()}/${
				this.match.id
			}/${this.referenceTradable.id || ""}`;
		},
		matchPriceWarning() {
			let o = this.match.offer;
			if (o.location.distance_max > 0) {
				if (this.trade == "SELL") {
					// sell offer with radius: must be delivery, i.e. freight cost on top
					return this.__("(plus freight costs)");
				} else {
					// buy offer with radius: must be pick-up, i.e. freight cost deducted
					return this.__("(minus freight costs)");
				}
			} else {
				return "";
			}
		},
		showFcaPrice() {
			return this.referenceTradable.location.mode == "FCA";
		},
		showExtraTextRow() {
			return this.match.offer.extra.text != null;
		},
		priceContainerCss() {
			return this.referenceTradable.user.type == "FARMER" &&
				this.referenceTradable.trade == "SELL"
				? "col-span-7 md:col-span-4 flex flex-nowrap items-center justify-center leading-4"
				: "col-span-7 xl:col-span-7 flex flex-nowrap items-center justify-center leading-4";
		},
	},
	data() {
		return {
			o: options,
		};
	},
};
</script>
